export const initSearchBlock = function() {
  const btnSearch = document.querySelectorAll('[data-search="btn"]');
  const searchContainer = document.querySelector('[data-search="container"]');

  const closeSearchContainer = () => {
    searchContainer.classList.remove('is-active');
    document.removeEventListener('click', handleClickOutside);
    document.removeEventListener('keydown', handleEscape);
  };

  // Обработчик клика вне контейнера
  const handleClickOutside = (event) => {
    if (searchContainer && !searchContainer.contains(event.target) && !event.target.closest('[data-search="btn"]')) {
      closeSearchContainer();
    }
  };

  // Обработчик нажатия Esc
  const handleEscape = (event) => {
    if (event.key === 'Escape') {
      closeSearchContainer();
    }
  };

  // Обработчик клика по кнопкам поиска
  btnSearch.forEach((el) => {
    el.addEventListener('click', () => {
      if (!searchContainer) {
        return;
      }

      const wasActive = searchContainer.classList.contains('is-active');
      searchContainer.classList.toggle('is-active');
      const isActive = !wasActive;

      if (isActive) {
        // Добавляем обработчики при открытии
        document.addEventListener('click', handleClickOutside);
        document.addEventListener('keydown', handleEscape);

        // Фокус на поле ввода
        const input = searchContainer.querySelector('input[type="search"]');
        if (input) {
          input.focus();
        } else {
          closeSearchContainer();
        }
      }
    });
  });
};
